import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { getRouteFromPathName } from '../../../../shared/utils/localStorage';
import { storageKeys } from '../../../../stores/DebuggerStore';
import { Badge, ConnectionStatus } from './Styles';

const ConnectionStatusContainer = observer(
  ({
    connected,
    networkConnected,
  }) => {
    const {
      DebuggerStore: {
        errorsExistInLog,
        getDebugArrayValue,
        removeDebugArrayItem,
        setDebugArrayItem,
        shouldReadLogWhenConnected,
      },
    } = useStores();

    const toggleViewer = () => {
      const key = storageKeys.showViewer;
      const slug = getRouteFromPathName()?.toLowerCase();
      const exists = getDebugArrayValue(key).includes(slug);
      exists ? removeDebugArrayItem(key, slug) : setDebugArrayItem(key, slug);
    };

    const isConnected = connected && networkConnected;

    return (
      <>
        {!isConnected && (
          <ConnectionStatus
            bgColor="#ff0000"
            color="white"
            data-testid="connection-status"
            hover
            key={`not-connected${
              errorsExistInLog ? `-${errorsExistInLog}` : ''
            }`}
            onClick={toggleViewer}
          >
            <div>
              <i aria-hidden="true" className="fa fa-times-circle-o fa-2" />
              NOT CONNECTED
            </div>
            {errorsExistInLog && (
              <Badge bgColor="#fff" color="#f00">
                {errorsExistInLog}
              </Badge>
            )}
          </ConnectionStatus>
        )}
        {isConnected && errorsExistInLog && (
          <ConnectionStatus
            bgColor="#ffa600"
            color="#000"
            data-testid="connection-status"
            hover
            onClick={toggleViewer}
            title="CONNECTED, BUT THERE WERE ERRORS. AUCTION MAY CONTINUE... (CLICK TO VIEW ERRORS)"
          >
            <i aria-hidden="true" className="fa fa-exclamation-triangle" />
            CONNECTED
          </ConnectionStatus>
        )}
        {isConnected && !errorsExistInLog && (
          <ConnectionStatus
            bgColor="#21BA45"
            color="white"
            data-testid="connection-status"
            hover={shouldReadLogWhenConnected}
            onClick={toggleViewer}
            title={shouldReadLogWhenConnected ? 'CLICK TO VIEW LOG' : ''}
          >
            <i aria-hidden="true" className="fa fa-check-circle-o fa-2" />
            CONNECTED
          </ConnectionStatus>
        )}
      </>
    );
  },
);

ConnectionStatusContainer.propTypes = {
  connected: PropTypes.bool,
  networkConnected: PropTypes.bool,
};

ConnectionStatusContainer.defaultProps = {
  connected: false,
  networkConnected: false,
};

export default ConnectionStatusContainer;
